
export type SearchUsers200Sort = {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
};
